export default __webpack_public_path__ + "static/media/ketoenergybar@2x.eaca52d8.jpg";